<div class="circle-loading">
  <svg
    width="96"
    height="96"
    viewBox="-12 -12 120 120"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: rotate(-90deg)"
  >
    <circle
      r="38"
      cx="48"
      cy="48"
      stroke="#062B4D"
      stroke-width="5"
      stroke-linecap="round"
      stroke-dashoffset="0"
      fill="transparent"
      stroke-dasharray="238.64000000000001px"
    ></circle>
    <circle
      r="38"
      cx="48"
      cy="48"
      fill="transparent"
      stroke="#e0e0e0"
      stroke-width="6"
      stroke-dasharray="238.64000000000001px"
      [attr.stroke-dashoffset]="-filledValue"
    ></circle>
  </svg>
  <span>{{ progressPercentage }}%</span>
</div>
